import subscriptionRoutes from './routes';
import LicenseSlice from './store/licenses.store';

export { subscriptionRoutes };

const moduleConfig = {
  routes: subscriptionRoutes,
  reducers: { licenses: LicenseSlice.reducer },
};

export default moduleConfig;
